const deviceColors = {
  color1: { primary: "primary", secondary: "primaryLight" },
  color2: { primary: "tint3", secondary: "tint3Light" },
  color3: { primary: "command-tint2", secondary: "command-tint2Light" },
  color4: { primary: "tint4", secondary: "tint4Light" },
  color5: { primary: "command-tint4", secondary: "command-tint4Light" },
  color6: { primary: "command-tint8", secondary: "command-tint8Light" },
  other: { primary: "secondary", secondary: "secondaryLight" }
};

const deviceMarks = { 0: "A", 1: "B", 2: "C", 3: "D" };

export { deviceColors, deviceMarks };
